import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table for transactions by player first level reports.
 */
export default class TableTransactionsByPlayerFirstLevelReports extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            id: 'datatable', // ID for the datatable
                            view: 'datatable', // Webix datatable component
                            scroll: 'xy', // Enable both horizontal and vertical scrolling
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                // Column definitions for the datatable
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    width: 200,
                                    format: dateFormat, // Date format for the column
                                },
                                {
                                    id: 'UniqueTransactionId',
                                    header: _('Identificador único de la transacción'),
                                    width: 250,
                                },
                                {
                                    id: 'PlayerId',
                                    header: _('Identificador único del jugador'),
                                    width: 250,
                                },
                                {
                                    id: 'PlayerName',
                                    header: _("Nombre del jugador"),
                                    width: 350,
                                },
                                {
                                    id: 'DocumentType',
                                    header: _('Tipo de documento'),
                                    width: 200,
                                },
                                {
                                    id: 'DocumentNumber',
                                    header: _('Numero de documento'),
                                    width: 250,
                                },
                                {
                                    id: 'BetStatus',
                                    header: _('Estado de la apuesta'),
                                    width: 200,
                                },
                                {
                                    id: 'Bet',
                                    header: _('Apuesta'),
                                    width: 300,
                                },
                                {
                                    id: 'Award',
                                    header: _('Premio'),
                                    width: 300,
                                },
                                {
                                    id: 'Odds',
                                    header: _('Cuota'),
                                    width: 150,
                                },
                                {
                                    id: 'SelectedQuantity',
                                    header: _('Cantidad de Selecciones'),
                                    width: 200,
                                },
                                {
                                    id: 'Type',
                                    header: _('Tipo'),
                                    width: 200,
                                },
                                {
                                    id: 'TicketDate',
                                    header: _('Fecha de ticket'),
                                    width: 250,
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Custom date format
                                },
                                {
                                    id: 'CalculationDate',
                                    header: _('Fecha de calculo'),
                                    width: 250,
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Custom date format
                                },
                                {
                                    id: 'TransactionLocation',
                                    header: _('Lugar de transacción'),
                                    width: 250,
                                },
                            ],
                            on: {
                                // Event handlers for the datatable
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        // Show loading overlay
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        // Show no data overlay
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable mathematical operations
                            datafetch: 10, // Number of records to fetch at a time
                            pager: 'pagerA', // ID of the pager component
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        let url = devConfig.geturlApi() + 'es/Financial/GetIncomeFirstLevel'; // API URL for data fetching

        this.on(
            // Event listener for filtering transactions
            this.app,
            'transactionsByPlayerFirstLevel:filter',
            (filterData) => {
                let object = Object.entries(filterData); // Convert filter data to entries
                let string1 = ''; // Query string for API request

                for (let i = 0; i < object.length; i++) {
                    // Iterate through filter data
                    if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                        if (object[i][0] == 'Datepicker') {
                            // Handle date range filter
                            let date = object[i][1].split(' - ');
                            string1 = string1 + '&dateFrom=' + date[0];
                            string1 = string1 + '&dateTo=' + date[1];
                        } else {
                            if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                            } else {
                                if (object[i][0] == 'Date') {
                                    // Handle single date filter
                                    let date = object[i][1].replace(' 00:00:00', '');
                                    string1 = string1 + '&dateFrom=' + date;
                                    string1 = string1 + '&dateTo=' + date;
                                }
                            }
                        }
                    } else {
                        if (typeof object[i][1] === 'object') {
                            // Handle object type filters
                            let object2 = Object.entries(object[i][1]);
                            for (let j = 0; j < object2.length; j++) {
                                if (object2[j][1] !== null) {
                                    if (object2[j][0] === 'start') {
                                        // Handle start date
                                        let d = new Date(object2[j][1]);
                                        let dateFrom =
                                            'dateFrom=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateFrom;
                                    } else {
                                        if (object2[j][0] === 'end') {
                                            // Handle end date
                                            let d = new Date(object2[j][1]);
                                            let dateTo =
                                                'dateTo=' +
                                                d.getFullYear() +
                                                ':' +
                                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                                ':' +
                                                ('00' + d.getDate()).slice(-2) +
                                                ' ' +
                                                ('00' + d.getHours()).slice(-2) +
                                                ':' +
                                                ('00' + d.getMinutes()).slice(-2) +
                                                ':' +
                                                ('00' + d.getSeconds()).slice(-2);
                                            string1 = string1 + '&' + dateTo;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                grid.clearAll(); // Clear existing data in the grid
                $$('consultDesk').define('disabled', true); // Disable consult desk during loading
                grid.load(
                    // Load data into the grid
                    url + '?start=0&count=' + grid.data.$pagesize + string1,
                )
                    .then((response) => {
                        $$('consultDesk').define('disabled', false); // Re-enable consult desk after loading
                    })
                    .catch((e) => {
                        $$('consultDesk').define('disabled', false); // Re-enable consult desk on error
                    });
                $$('filterPopup').hide(); // Hide filter popup
            },
        );

        $$('pagerA').attachEvent('onAfterPageChange', function (page) {
            // Event for page change in pager
            webix.delay(
                // Delay execution to allow for loading
                function () {
                    if (page != '0') {
                        chargeTable(); // Load data for the new page
                    }
                },
                '',
                '',
                100,
            );
        });

        this.on(this.app, 'changeSize', (filterData) => {
            // Event for changing size
            chargeTable(); // Load data when size changes
        });

        /**
         * Loads data into the grid based on pagination.
         */
        function chargeTable() {
            let size = grid.getPager().config.size; // Get page size
            let page = grid.getPage(); // Get current page
            let first = size * page; // Calculate starting index
            let last = first + size - 1; // Calculate ending index
            grid.load(
                // Load data into the grid
                url + '?start=' + first + '&count=' + (last + 1) + filter,
            );
        }
    }
}

// FILE DOCUMENTED
